import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CommonSwipeableDrawer from '../responsive/CommonSwipeableDrawer';

const DeletionConfirmationDialog = (props) => {
  const { row, nameField = '', deleteText = '' } = props;
  const entryState = useSelector((state) => state.dialog.openDeletionConfirmationDialog);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch({ type: 'dialog/set', openDeletionConfirmationDialog: { open: false, props: {} } });
  };

  const childrenContent = (
    <>
      <Box sx={{ padding: '16px' }}>
        <Typography sx={{ display: 'flex', justifyContent: 'center', fontSize: '16px', fontWeight: '700', mb: '4px' }}>
          app.roadeazy.com.says
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', fontSize: '14px', fontWeight: '400' }}>
          Are you sure you want to delete {deleteText}?
        </Box>
        <Typography sx={{ display: 'flex', justifyContent: 'center', fontSize: '14px', fontWeight: '400' }}>
          This operation cannot be undone!
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: '40px', gap: '8px' }}>
          <Button sx={{ width: '50%', height: '40px', fontSize: '16px', fontWeight: '700' }} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            sx={{
              width: '50%',
              height: '40px',
              background: '#EC5962',
              fontSize: '16px',
              fontWeight: '700',
              color: (theme) => theme.palette.pdark.contrastText,
              borderColor: '#EC5962',
              '&:hover': { backgroundColor: '#EC5962', borderColor: '#EC5962' },
            }}
            onClick={() => props.handleDelete(row.entityId)}
          >
            Delete
          </Button>
        </Box>
      </Box>
    </>
  );
  return (
    <div>
      <CommonSwipeableDrawer anchor='bottom' open={entryState.open} onOpen={handleClose} onClose={handleClose} minHeight='180px' height='190px'>
        {childrenContent}
      </CommonSwipeableDrawer>
    </div>
  );
};

export default DeletionConfirmationDialog;
